import { useEffect, useState } from 'react';
import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';

const SOURCING_DISCOUNT_PRICE_IN_CENTS = 4900;

const getDomainExpertSourcingPrice = async () => {
    try {
        const { data } = await axios.get(pathfinder('get_expert_sourcing_feature_price'));
        return data;
    } catch (err) {
        logger.warn(err as any, { message: 'Failed to fetch domain expert sourcing price' });
        return undefined;
    }
};

export const useDomainExpertSourcingPrice = () => {
    const [sourcingDiscounPriceInCents, setSourcingDiscounPriceInCents] = useState<number>(
        SOURCING_DISCOUNT_PRICE_IN_CENTS
    );

    useEffect(() => {
        getDomainExpertSourcingPrice()
            .then((data) => {
                setSourcingDiscounPriceInCents(data?.sourcingDiscounPriceInCents || SOURCING_DISCOUNT_PRICE_IN_CENTS);
            })
            .catch((e) => {
                logger.warn(e, { message: 'Failed to fetch domain expert sourcing price' });
            });
    }, []);

    return { sourcingDiscounPriceInCents };
};
